// extracted by mini-css-extract-plugin
module.exports = {"course":"single-course-module--course--3txVo","container":"single-course-module--container--2D3hd","footer":"single-course-module--footer--ccNNb"};